import axios from "axios";

const customAxios = axios.create({
  baseURL: process.env.NODE_ENV !== "production" ? "http://localhost:5001" : "",
  timeout: 10000,
  headers: {
    "Access-Control-Allow-Origin":
      process.env.NODE_ENV !== "production" ? "http://localhost:3000" : "",
    "Access-Control-Allow-Credentials": true,
    "Access-Control-Allow-Methods": "GET, POST, OPTIONS",
    "Access-Control-Allow-Headers": "Origin, Content-Type, Accept",
  },
});

// Step-2: Create request, response & error handlers
const requestHandler = (request) => {
  // Attach the session token on every request. `setAuthToken` also sets it as
  // a default header, but only at App mount and on login -- a token written to
  // localStorage by any other path (another tab, a link flow) would otherwise
  // not be sent, and admin-only endpoints would answer 401. Reading it here
  // makes the header track localStorage for the whole app.
  const token =
    typeof window !== "undefined" ? window.localStorage.getItem("token") : null;

  if (token) {
    request.headers["x-auth-token"] = token;
  } else {
    delete request.headers["x-auth-token"];
  }

  return request;
};

const errorHandler = (error) => {
  return Promise.reject(error);
};

// Step-3: Configure/make use of request & response interceptors from Axios
// Note: You can create one method say configureInterceptors, add below in that,
// export and call it in an init function of the application/page.
customAxios.interceptors.request.use(
  (request) => requestHandler(request),
  (error) => errorHandler(error)
);

customAxios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data

    return response;
  },
  function (error) {
    // Guard: network errors / timeouts have no `error.response`, so reading
    // `error.response.status` directly would throw and mask the real error.
    const status = error.response?.status;
    const msg = error.response?.data?.msg;

    // An expired or invalid token clears the stored token and sends the user
    // to the login screen.
    if (status === 401 && msg === "InValidToken") {
      localStorage.removeItem("token");
      window.location = "/admin";
    }

    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

// customAxios.interceptors.response.use(
//   (response) => responseHandler(response),
//   (error) => errorHandler(error)
// );

// Step-4: Export the newly created Axios instance to be used in different locations.
export default customAxios;
